{
  "display_name": "Christianna",
  "expires_at_human": "May 16, 2026",
  "household_name": "Andre's household",
  "inviter_display_name": "Andre",
  "role": "Owner",
  "signup_url": "https://dev.hearthfire.ai/signup?token=abc123"
}
